@if(showProcessDataCards()) {
<div class="card-group">

  <div class="card" (click)="showFastFetchView()" (keydown.enter)="showFastFetchView()">
    <div class="card-header bg-secondary text-white lt-card">Fast Fetch Loans</div>
    <div class="card-body w-75">
      <p class="card-text">Send loans to queue for processing</p>
    </div>
  </div>

  <div class="card" (click)="showDataSwapView()" (keydown.enter)="showDataSwapView()">
    <div class="card-header bg-secondary text-white lt-card">Get Processed Info</div>
    <div class="card-body w-75">
      <p class="card-text">Get loan and file xmls already processed</p>
    </div>
  </div>
</div>
}
@else {
<div>
  <button matButton="elevated" class="goback-button" (click)="showProcessDataCardView()">Go Back</button>
</div>
<div>
  @if(showDataSwap()) {
    <app-lba-dataswap [client]="client()" [integration]="integration()" [isInTab]="true" [integrationIdentifiers]="identifiers()" #lbaDataSwap />
  }
  @if(showFastFetch()) {
    <app-fastfetch [integrationInfo]="computedIntegrationInfo()" [integration]="integration()" [isInTab]="true" #fastFetch />
  }
</div>
}